import clsx from "clsx";
import React from "react";

import {
  LibraryPrivacy,
  LibrarySort,
} from "@growth-machine-llc/stridist-api-client";
import {
  JourneyAnchors,
  AllOption,
  LibraryPrivacyFilter,
} from "../../constants";
import { CoachLibraryHeader } from "../library/CoachLibraryHeader";
import { CoachLibraryHeaderFiltersBaseProps } from "../exercise-library/CoachExerciseLibraryHeaderFilters";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const ComponentTemplatePrivacyOptions = (isTeamAccount: boolean) => [
  {
    value: AllOption,
    tooltip: "All component templates",
    label: "All",
  },
  {
    value: LibraryPrivacy.PRIVATE,
    tooltip: "Private component templates",
    label: "Private",
  },
  ...(isTeamAccount
    ? [
        {
          value: LibraryPrivacy.TEAM,
          tooltip: "Team component templates",
          label: "Team",
        },
      ]
    : []),
  {
    value: LibraryPrivacy.PUBLIC,
    tooltip: "Public component templates",
    label: "Public",
  },
];

export interface CoachComponentTemplateLibraryHeaderFiltersProps
  extends CoachLibraryHeaderFiltersBaseProps {
  sortKey: LibrarySort;
  onChangeSortKey?: (sortKey: LibrarySort) => void;
  showFilterByType?: boolean;
}

export function CoachComponentTemplateLibraryHeaderFilters(
  props: CoachComponentTemplateLibraryHeaderFiltersProps,
) {
  const {
    className,
    query,
    onChangeQuery,
    privacy,
    onChangePrivacy,
    defaultQuery,
    showResetButton,
    disabledResetButton,
    showFilterByType,
    onResetFilters,
  } = props;

  const { isTeamAccount } = useCurrentUser();

  return (
    <CoachLibraryHeader<LibraryPrivacyFilter>
      className={className}
      query={query}
      defaultQuery={defaultQuery}
      searchPlaceholder={`Search by name`}
      onChangeQuery={onChangeQuery}
      toggleOptions={
        showFilterByType
          ? ComponentTemplatePrivacyOptions(isTeamAccount)
          : undefined
      }
      toggleValue={privacy}
      onChangeToggle={onChangePrivacy}
      toggleClassName={clsx(JourneyAnchors.COMPONENT_TEMPLATE_PRIVACY_FILTER)}
      showResetButton={showResetButton}
      disabledResetButton={disabledResetButton}
      onResetFilters={onResetFilters}
    />
  );
}
